import script from "./PdArrowLink.vue?vue&type=script&setup=true&lang=js"
export * from "./PdArrowLink.vue?vue&type=script&setup=true&lang=js"

import "./PdArrowLink.vue?vue&type=style&index=0&id=3e54f922&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e54f922"]])

export default __exports__